import React from "react";
import styled from "styled-components";
import {ReactSVG} from "react-svg";
import {color, compose, variant} from "styled-system";
import css from '@styled-system/css'

const StyledIcon = styled(ReactSVG)<IconProps>(
  ({color}) =>
    css({
      svg: {
        height: "100%",
        width: "100%",
        path: {
          fill: color ? `${color}` : "",
        }
      }
    }),
  ({size}) =>
    variant({
      prop: "variant",
      variants: {
        xSmall: {
          div: {
            width: size || "1rem",
            height: size || "1rem",
            display: "flex",
            alignItems: "center"
          },
        },
        small: {
          div: {
            width: size || "1.25rem",
            height: size || "1.25rem",
            display: "flex",
            alignItems: "center"
          },
        },
        medium: {
          div: {
            width: size || "1.5rem",
            height: size || "1.5rem",
            display: "flex",
            alignItems: "center"
          },
        },
        large: {
          div: {
            width: size || "2rem",
            height: size || "2rem",
            display: "flex",
            alignItems: "center"
          },
        },
      },
    }),
  compose(color)
);

interface IconProps {
  /**
   * Name of the icon
   */
  children?: string;
  /**
   * Icon color
   */
  color?: string;
  /**
   * Icon class
   */
  className?: string;
  /**
   * Icon size
   */
  variant?: "xSmall" | "small" | "medium" | "large";
  /**
   * Click event
   */
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({children, ...props}: IconProps) => {
  return (
    <StyledIcon
      src={`/icons/${children}.svg`}
      {...props}
    />
  )
}

export default Icon;
